import Vue from 'vue'

Vue.component('SiteSearchListItem', {
  template: '#site-search-list-item',
  props: ['link', 'summary']
})